import { useTranslation } from 'next-i18next';
import React from 'react';
import styled from 'styled-components';
import { ProductDescription } from '@hotelplan/components.common.product';
import { useObjectId } from '@hotelplan/libs.context.object-id';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import PdpDestinationAttributes from 'components/domain/pdp//PdpDestinationAttributes';
import PdpDescriptionStaticMap from 'components/domain/pdp/PdpDescriptionStaticMap';
import PdpPageContainer from 'components/domain/pdp/PdpPageContainer';
import { useGetPdpDescriptionQuery } from 'graphql/pdp/GetPdpDescription.generated';

const DescriptionPageContent = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: ['column', 'row'],
    gap: [null, 4],
    justifyContent: 'space-between',
  })
);

const DescriptionPageMain = styled.div(
  sx2CssThemeFn({
    flex: [null, '1'],
  })
);

const DescriptionPageTitle = styled.div(
  sx2CssThemeFn({
    mb: 2,
    '.description-title': {
      fontSize: ['18px', '26px'],
      color: 'secondary',
    },

    h3: {
      color: '#999',
      fontSize: ['18px', '26px'],
    },
  })
);

const DescriptionPageSidebar = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    flex: [null, '1'],
    mb: [4, 0],
    '.attributes-list': {
      flexDirection: 'column',
    },
  })
);

const StaticMap = styled(PdpDescriptionStaticMap)(
  sx2CssThemeFn({
    mb: 4,
    mx: [4, 0],
  })
);

const PdpItinerary = (): React.ReactElement => {
  const [t] = useTranslation();
  const { id } = useObjectId();

  const { data, loading } = useGetPdpDescriptionQuery({
    variables: { id },
  });

  const staticMaps = data?.pdp.content.description.staticMaps;

  return (
    <>
      <PdpPageContainer>
        <DescriptionPageContent>
          <DescriptionPageMain>
            <DescriptionPageTitle>
              <h2 className="description-title">{t(`pdp:itinerary.title`)}</h2>
            </DescriptionPageTitle>
            {data?.pdp.content.description.featureRatings && (
              <ProductDescription
                blocks={[data?.pdp.content.description.programm]}
              />
            )}
          </DescriptionPageMain>
          <DescriptionPageSidebar>
            <StaticMap staticMaps={staticMaps} loading={loading} />
            {data?.pdp.content.description.featureRatings && (
              <PdpDestinationAttributes
                attributes={data?.pdp.content.description.featureRatings}
              />
            )}
          </DescriptionPageSidebar>
        </DescriptionPageContent>
      </PdpPageContainer>
    </>
  );
};

export default PdpItinerary;
